<script setup>
import {ref} from "vue";
import DropdownRow from "@/components/global-themed/inputs/dropdown/DropdownRow.vue";
import BaseDropdown from "@/components/global-themed/inputs/dropdown/BaseDropdown.vue";
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";

const showDropdown = ref(false);

const emit = defineEmits(['edit-layout', 'add-widget', 'my-widgets', 'shareable-link']);

const handleEditLayout = () => {
  showDropdown.value = false;
  emit('edit-layout');
};

const handleAddWidget = () => {
  showDropdown.value = false;
  emit('add-widget');
};

const handleMyWidgets = () => {
  showDropdown.value = false;
  emit('my-widgets');
};

const handleShareableLink = () => {
  showDropdown.value = false;
  emit('shareable-link');
};
</script>

<template>
  <BaseDropdown
    v-model:dropdownOpen="showDropdown"
  >
    <template #trigger="{ toggleDropdown }">
      <SquareIconButton
        size="small"
        variant="primary"
        class="tw-p-3 tw-border-2 tw-rounded-xl"
        @click="toggleDropdown"
      >
        <svg-vue
          class="tw-w-6 tw-flex-shrink-0"
          icon="icons/settings-cog"
        />
      </SquareIconButton>
    </template>

    <template #content>
      <DropdownRow @click="handleEditLayout">
        <svg-vue
          class="tw-text-neutral-900 tw-w-5 tw-flex-shrink-0 !tw-grow-0"
          icon="icons/pencil_line"
        />
        <span>Edit Layout</span>
      </DropdownRow>

      <DropdownRow @click="handleAddWidget">
        <svg-vue
          class="tw-text-neutral-900 tw-w-5 tw-flex-shrink-0 !tw-grow-0"
          icon="icons/plus"
        />
        <span>Add Widget</span>
      </DropdownRow>

      <DropdownRow @click="handleMyWidgets">
        <svg-vue
          class="tw-text-neutral-900 tw-w-5 tw-flex-shrink-0 !tw-grow-0"
          icon="icons/folder"
        />
        <span>My Widgets</span>
      </DropdownRow>

      <DropdownRow @click="handleShareableLink">
        <svg-vue
          class="tw-text-neutral-900 tw-w-5 tw-flex-shrink-0 !tw-grow-0"
          icon="icons/share"
        />
        <span>Shareable link</span>
      </DropdownRow>
    </template>
  </BaseDropdown>
</template>
